import RemoveButtonWithModal from './RemoveButtonWithModal';

export default RemoveButtonWithModal;
export { RemoveButtonWithModal };
